import styled from 'styled-components';

export const MobilePopupWrapper = styled.div`
  overflow: hidden;
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 486px;
  background: #fff;
  border-radius: 30px 30px 0 0;
  z-index: 11;

  .container {
    img {
      width: 100%;
      max-height: 230px;
      object-fit: cover;
      cursor: pointer;
    }
    .title {
      overflow: hidden;
      width: 100%;
      height: 48px;
      padding: 0 10px;
      border-bottom: 1px solid #e0e0e0;
      font-size: 1.4rem;
      font-weight: 700;
      line-height: 48px;
      white-space: nowrap;
      text-overflow: ellipsis;
      word-break: break-all;
      cursor: pointer;
    }

    .btnGroupWrapper {
      display: flex;
      justify-content: space-between;

      button {
        height: 50px;
        padding: 0 20px;
        font-size: 1.4rem;
      }
    }
  }
`;

export const PCPopupWrapper = styled.div`
  overflow: hidden;
  position: fixed;
  left: 12%;
  bottom: 15%;
  width: 320px;
  background: #fff;
  border-radius: 20px;
  border: 1px solid #e0e0e0;
  .container {
    position: relative;
    padding: 60px 25px 20px;
    img {
      width: 100%;
      max-height: 170px;
      margin-bottom: 20px;
      object-fit: cover;
    }

    .title {
      overflow: hidden;
      width: 100%;
      padding-bottom: 15px;
      font-size: 1.4rem;
      font-weight: 700;
      white-space: nowrap;
      text-overflow: ellipsis;
      word-break: break-all;
    }
    .content {
      display: -webkit-box;
      margin-bottom: 20px;
      max-height: calc(2.2rem * 5);
      font-size: 1.2rem;
      line-height: 2.2rem;
      color: #777;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 5; /* 표시할 줄 수 (2줄) */
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .btnGroupWrapper {
    display: flex;

    button {
      flex: 1;
      text-align: center;
      height: 54px;
      color: #fff;
      background: #555;
      font-size: 1.6rem;
      &:last-of-type {
        background: #02a4ff;
      }
    }
  }

  .btnClose {
    position: absolute;
    top: 14px;
    right: 20px;
  }
`;
